

import {
  GET_USER_DETAIL_REQUEST,
  GET_USER_DETAIL_FAIL,
  GET_USER_DETAIL_SUCCESS,
} from "../../constants/actions";

const initialState = {
  loading: false,
  loginSucces: false,
  usersDetails:{},
  
  error: false,
};


const userDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_DETAIL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_USER_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        loginSucces: true, 
        usersDetails: action.payload,
      };
     
   
    case GET_USER_DETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
      };

    
    default:
      return state;
  }
};

export default userDetailsReducer;
